import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "table-header-info",
  "use": "table-header-info-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"table-header-info\">\n    <g fill=\"#03ADEF\" fill-rule=\"evenodd\">\n        <circle cx=\"9\" cy=\"9\" r=\"8.5\" fill-opacity=\".1\" stroke=\"#03ADEF\" />\n        <text font-family=\"Nexa-Heavy, Nexa\" font-size=\"14\" font-weight=\"600\" letter-spacing=\".122\">\n            <tspan x=\"4.753\" y=\"14\">?</tspan>\n        </text>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol